import React from 'react';

export const Label = ({ label, removeFromSelected }) => (
    <div className="relevance-label">
        {label.name} <div onClick={() => removeFromSelected(label)}>×</div>
    </div>
);
